module.exports = __webpack_public_path__ + "static/tractor_hw-0c3f00c53a1cb466a911e0b0881d5a1f.jpg";